import script from "./OrganizationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationPage.vue?vue&type=style&index=0&id=18fe0a99&scoped=true&lang=css"
script.__scopeId = "data-v-18fe0a99"

export default script